<template>
  <div style="font-size: 14px;display: flex;background-color: #0f0f1e;overflow: auto;">
    <div style="height: 50px;">
      <img src="../../../public/img/logo.png" style="height: 40px;margin: 10px 0 0 90px;cursor: pointer;" @click="homePage">
    </div>
    <div v-for="(item,index) in menus" :key="index" :class="'play-menu '+(menuIndex === index?'play-menu-active':'')" @click="selMenu(index)">
      {{item}}
    </div>
    <div class="my-play-search" style="flex: 1;text-align: right;">
      <el-input placeholder="" v-model="kw" style="width: 500px;margin: 10px 20px 0 0;" clearable>
        <el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>
      </el-input>
    </div>
    <div style="width: 330px;display: flex;margin-top: 5px;">
      <div v-if="isLogin" style="color: antiquewhite;padding-top: 10px;">
        {{account}} 
      </div>
      <div v-if="isLogin" style="color: antiquewhite;padding-top: 10px;padding-left: 20px;">
        余额 {{balance}}
      </div>
      <div v-if="isLogin" style="color: antiquewhite;padding-top: 10px;padding-left: 20px;" @click="logout">
       退出
      </div>
      <div v-else>
        <el-avatar icon="el-icon-user-solid pointer" style="margin-top: 5px;" @click.native="login"></el-avatar>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        kw: '',
        menuIndex: 1,
        menus:['首页','电影','电视剧','短视频','预告片','资讯'],
        account:'',
        balance:0,
        isLogin:false,
      };
    },
    created (){
        this.account = localStorage.getItem('account');
        this.balance = localStorage.getItem('balance');
        console.log(localStorage.getItem('account'));
        if(typeof this.account== "undefined" || this.account== null || this.account== ""){
          this.isLogin=false;
        }else{
          this.isLogin=true;
        }
      },
    mounted() {
    },
    methods: {
      selMenu(index){
        this.menuIndex = index;
        switch (index) {
            case 0:
              this.$router.push({path: '/index'});
              break;
            case 1:
              this.$router.push({path: '/dianying'});
              break;
            case 2:
              this.$router.push({path: '/dianshiju'});
              break;
            case 3:
            this.$router.push({path: '/dianshiju'});
              break;
            case 4:
            this.$router.push({path: '/dianshiju'});
              break;
            case 5:
            this.$router.push({path: '/list'});
              break;
            default:
              this.$router.push({path: '/index'});
          }
      },
      homePage(){
        this.$router.push({path: '/index'});
      },
      login(){
        this.$router.push({path: '/login'});
      },
      logout(){

      },
      toSearch(){
        console.log('search');
        if(this.kw==''){
          console.log('为空');
        }else{
          this.$router.push({path:'/search?kw='+this.kw})
        }
      }
    }
  };
</script>

<style>
  .play-menu{
    margin: 0 10px;
    font-size: 15px;
    padding-top: 10px;
    line-height: 60px;
    color: #FFFFFF;
    white-space: nowrap;
  }
  .play-menu:hover{
    cursor: pointer;
    color: #ff5c38 !important;
  }
  .play-menu-active{
    color: #ff5c38;
  }
  .but:hover{
    cursor: pointer;
    color: #ff0e0b !important;
  }
  .my-play-search .el-input__inner{
    background-color: #272735;
    border-color: #272735;
    color: #ffffff;
  }
  .my-play-search .el-input-group__append, .el-input-group__prepend{
    background-color: #ff5c38!important;
    color: #ffffff!important;
    border: none!important;
  }
  .my-play-search .el-input-group__append:hover{
    background-color: #ff0e0b !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/top.vue